import { Drawer } from 'antd';
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { genderOptions,jobStatusOptions,residencyOptions } from 'utils/constants';

// Referral options for filter
const referralOptions = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];
const FilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [placement] = useState('right');  
   const {
    nationality, nationalityLoading
} = useSelector((state) => state.common);

const [nationalityOption, setNationalityOption] = useState([]);


useEffect(()=>{
    let _nationality = nationality.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    setNationalityOption(_nationality)
},[nationality])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
          if(key === "nationality"){
            return selectedValue.value
          }
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
         <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>
        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("applied_at_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "applied_at_after")}} 
        id="search" 
        label={"Applied at after"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("applied_at_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "applied_at_before")}} 
        id="search" 
        label={"Applied at before"} 
        />
        </div>


        {/* <div className='col-12 mb-3' >
        <FilterInput   inputValue={setInputValue("search")}  handleInputChange={e=>{handleInputChange(e.target.value, "search")}} id="search" placeholder={searchPlaceholder} />
        </div> */}
       

        {/* <div className='col-12 mb-3' >
        <FilterSelect loading options={[]} value={""} placeholder={"Select destination"}/>
        </div> */}

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "gender")}} optionLabel={"label"} optionValue={'value'} options={genderOptions} value={setFilterValue("gender")} placeholder={"Gender"}/>
        </div>



        <div className='col-12 mb-3' >
        <FilterSelect isMulti={true} isClearable={true}  onChange={e=>{handleFilterChange(e, "nationality")}} optionLabel={"label"} optionValue={'value'}  options={nationalityOption} isLoading={nationalityLoading}  value={setFilterValue("nationality")} placeholder={"Nationality"}/>
        </div>

   
        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "status")}} optionLabel={"label"} optionValue={'value'} options={jobStatusOptions}  value={setFilterValue("status")} placeholder={"Status"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "residence_status")}} optionLabel={"label"} optionValue={'value'} options={residencyOptions}  value={setFilterValue("residence_status")} placeholder={"Residency Status"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "is_internal_referral")}} optionLabel={"label"} optionValue={'value'} options={referralOptions}  value={setFilterValue("is_internal_referral")} placeholder={"Employee Referral"}/>
        </div>

        <div className="col-12">
    <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>

       
    
     </div>

      </Drawer>
    </>
  );
};
export default FilterDrawer;